import { render } from "./Settings.vue?vue&type=template&id=22375070"
import script from "./Settings.vue?vue&type=script&lang=ts"
export * from "./Settings.vue?vue&type=script&lang=ts"

import "./Settings.vue?vue&type=style&index=0&id=22375070&lang=scss"
script.render = render

export default script